/**
 * Format helpers shared across the Auto-Dial Ops Center components.
 */

export const formatPct = (v, decimals = 0) => {
  const n = Number(v) || 0;
  return `${(n * 100).toFixed(decimals)}%`;
};

export const formatDelta = (deltaPp) => {
  const n = Number(deltaPp) || 0;
  if (n === 0) return '—';
  const arrow = n > 0 ? '▲' : '▼';
  return `${arrow} ${Math.abs(n).toFixed(1)}pp`;
};

export const formatDuration = (seconds) => {
  const s = Number(seconds) || 0;
  if (s <= 0) return '—';
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m === 0) return `${r}s`;
  return `${m}m ${String(r).padStart(2, '0')}s`;
};

export const formatAge = (seconds) => {
  const s = Number(seconds) || 0;
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return `${h}h ${rm}m ago`;
};

export const formatTimestamp = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch (e) {
    return String(iso);
  }
};

export const formatTime = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleTimeString();
  } catch (e) {
    return String(iso);
  }
};

export const reasonLabel = (reason) =>
  String(reason || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

// ─── CSV export helpers (shared by Deep Dive + Roster) ─────────────────────

/**
 * Convert an array of plain-object rows to a CSV string. Header row uses the
 * keys of the first row. Values containing commas, quotes, or newlines are
 * properly escaped with double quotes.
 */
export const toCsv = (rows) => {
  if (!rows || !rows.length) return '';
  const headers = Object.keys(rows[0]);
  const escape = (val) => {
    if (val == null) return '';
    const s = String(val).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const body = rows
    .map((r) => headers.map((h) => escape(r[h])).join(','))
    .join('\n');
  return `${headers.join(',')}\n${body}`;
};

/**
 * Trigger a browser download of the given CSV string. Cleans up the
 * blob URL after the click.
 */
export const downloadCsv = (filename, csv) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
